import { render } from "./ExportCustomAreas.vue?vue&type=template&id=47aff0ab"
import script from "./ExportCustomAreas.vue?vue&type=script&lang=js"
export * from "./ExportCustomAreas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__